/**
 * Returns the Jamaica states list to populate the select item.
 */
 export function gluky_addressfield_jm_states_list() {
  let temporalStates = [];
  const states =
      {
        '00':'No Aplica',
        '01':'Condado de Cornwall',
        '02':'Condado de Middlesex',
        '03':'Condado de Surrey',
      }

      Object.keys(states).map((res) => {
        temporalStates = [
          ...temporalStates,
          {
            name: states[res],
            code: res,
          },
        ];
      });
      return temporalStates;
}

/**
 * Returns the Jamaica cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_jm_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
             '00':
                        {
                          '00001':'No Aplica',
                        },
             '01':
                        {
                          '01114':'Parroquia de Hanover',
                          '01025':'Parroquia de Saint Elizabeth',
                          '01017':'Parroquia de Saint James',
                          '01022':'Parroquia de Trelawny',
                          '01018':'Parroquia de Westmoreland',
                        },

                    '02':
                        {
                          '02031':'Parroquia de Clarendon',
                          '02024':'Parroquia de Manchester',
                          '02030':'Parroquia de Saint Ann',
                          '02034':'Parroquia de Saint Catherine',
                          '02025':'Parroquia de Saint Mary',
                        },

                    '03':
                          {
                            '03013':'Parroquia de Kingston',
                            '03024':'Parroquia de Portland',
                            '03015':'Parroquia de Saint Andrew',
                            '03012':'Parroquia de Saint Thomas',
                          },

  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

